// @ts-strict-ignore
import React from 'react';
import { ValidatingFormComponent } from '@/hybrid/formbuilder/formBuilder.module';
import { Field, useForm } from 'react-final-form';
import { FormControl } from 'react-bootstrap';
import { getFormFieldProps, getValidationFunction } from '@/hybrid/formbuilder/formbuilder.utilities';
import _ from 'lodash';
import { useShowError } from '@/hybrid/formbuilder/hooks/useShowError';
import { FormFieldWrapper } from '@/hybrid/formbuilder/FormFieldWrapper';

export interface ValueWithSymbolIF extends ValidatingFormComponent<string> {
  component: 'ValueWithSymbolFormComponent';
  symbol: string | JSX.Element;
  label?: string;
  id?: string;
  min?: number;
  max?: number;
}

/**
 * Text input field (form component) with symbol/unit
 */
export const ValueWithSymbolFormComponent: React.FunctionComponent<ValueWithSymbolIF> = (props) => {
  const {
    name,
    testId = 'valueWithSymbol',
    label,
    symbol,
    onChange,
    validation,
    extendValidation,
    customErrorText,
    min,
    max,
  } = props;

  const defaultValidation = (value: string) => {
    if (!value) return true;

    const hasMin = _.isNumber(min),
      hasMax = _.isNumber(max);
    const numberValue = Number(value);
    if (hasMin || hasMax) {
      return (
        !_.isNumber(numberValue) ||
        _.isNaN(numberValue) ||
        (hasMin && numberValue < min) ||
        (hasMax && numberValue > max)
      );
    }

    return false;
  };

  const appliedValidation = getValidationFunction(defaultValidation, extendValidation, validation);
  const formState = useForm().getState();
  const { showError, setShowError } = useShowError(false);

  return (
    <FormFieldWrapper
      testId={testId}
      label={label}
      showError={showError}
      customErrorText={customErrorText}
      wrapperClassNames="flexBaseline">
      <Field name={name} validate={appliedValidation}>
        {({ input, meta }) => {
          const formFieldProps = getFormFieldProps(formState, input, meta, props);
          setShowError(formFieldProps.showError);

          return (
            <div className="input-group width-80">
              <FormControl
                name="value"
                value={formFieldProps.value}
                onChange={(e) => onChange(e.target.value)}
                data-testid={`${testId}Input`}
                min={min}
                max={max}
                isInvalid={showError}
              />
              <span className="input-group-text sq-btn input-md" data-testid={`${testId}Symbol`}>
                {symbol}
              </span>
            </div>
          );
        }}
      </Field>
    </FormFieldWrapper>
  );
};
